import React from "react";

const StoreHeader = () => {
  return (
    <div className="text-center mt-24">
      <h1 className="capitalize text-dark-blue text-6xl">
        Good Students Write It Down!
      </h1>
      <p className="mt-5 w-full md:w-2/3 m-auto text-gray-500">
        Good students are obsessed with growth. Growth is intentional. Writing
        is one way you express your intentionality towards growth. We want to
        help you 10x the quality of your life through writing. The biggest lie
        you'll tell yourself is: "I don't need to write it down, I'll remember
        it."
      </p>
    </div>
  );
};

export default StoreHeader;
